import React from "react";
import { View, Text } from "react-native";
import { COMPENSATION_PROFILE_LINK } from "../../screens/links";
import { openBrowser } from "../../screens/utils";
import CheckIcon from "../../svgs/CheckIcon";
import { Button } from "../../components";
import { colors } from "../../../theme";
import PopOver from "../PopOver";

interface CompensationPopoverProps {
  visible: boolean;
  onDismiss: () => void;
}

const BULLET_POINTS = [
  {
    emoji: "📈",
    text: "Empowers the PGA to champion greater earnings for all members and associates.",
  },
  {
    emoji: "💪",
    text: "Secures your competitive edge and keeps you proactive in career advancement.",
  },
  { emoji: "➕", text: "Earns 1 PDR per cycle." },
];

const BulletItem = ({ emoji, text }: { emoji: string; text: string }) => (
  <View className="flex-row items-center mb-3">
    <Text style={{ fontSize: 20, marginRight: 8 }}>{emoji}</Text>
    <Text style={{ fontSize: 16, flex: 1 }}>{text}</Text>
  </View>
);

const Title = () => (
  <View className="flex-row items-center mb-6">
    <CheckIcon width={30} height={30} stroke={colors.secondary.DEFAULT} />
    <Text className="text-title-5 font-700 ml-2">Employment Updated</Text>
  </View>
);

const Subtitle = () => (
  <Text className="text-regular-normal font-700 mb-6 text-center">Next on the Tee: Your Compensation</Text>
);

const PopoverActions = ({
  handleUpdateCompensationProfile,
  onDismiss,
}: {
  handleUpdateCompensationProfile: () => void;
  onDismiss: () => void;
}) => (
  <View className="flex-col">
    <Button
      size="large"
      mode="contained"
      className="text-white text-regular-tight mb-3 w-full"
      labelStyle="px-7"
      onPress={handleUpdateCompensationProfile}
    >
      Update Compensation Profile
    </Button>
    <Button size="large" mode="text" className="text-primary text-regular-tight w-full" onPress={onDismiss}>
      Close
    </Button>
  </View>
);

const CompensationPopover: React.FC<CompensationPopoverProps> = ({ visible, onDismiss }) => {
  const handleUpdateCompensationProfile = () => {
    openBrowser(COMPENSATION_PROFILE_LINK)();
    onDismiss();
  };

  return (
    <PopOver {...{ onDismiss, visible }}>
      <Title />
      <Subtitle />
      <View className="flex-start mb-6">
        {BULLET_POINTS.map((item) => (
          <BulletItem key={item.emoji} {...item} />
        ))}
      </View>
      <PopoverActions {...{ handleUpdateCompensationProfile, onDismiss }} />
    </PopOver>
  );
};

export default CompensationPopover;
